import React, { useEffect, useRef } from "react";

import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
// import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { IoMdPrint } from "react-icons/io";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
} from "../../../_helper/helper";
import { PRINT_ACCESS } from "../../../_contstants/common";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getKarigarAmountLedgerReport } from "../services/reports.services";
import { sumBy } from "lodash";

const KarigarAmountLedgerReportView: React.FC = () => {
  const dispatch = useAppDispatch();

  const params = useParams();
  const fromdate = params.fromdate;
  const todate = params.todate;
  const karigar_id = params.karigar_id;
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.reports.loading);
  const KarigarAmountLedgerReportList = useAppSelector(
    (state) => state.reports.KarigarAmountLedgerReportList
  );

  const isPrintAccess = checkAcessRights(
    "/karigar-amount-ledger-report",
    PRINT_ACCESS
  );

  const fetchKarigarAmountLedgerReport = async (payload: any) => {
    await dispatch(getKarigarAmountLedgerReport(payload));
  };

  useEffect(() => {
    if (fromdate && todate && karigar_id) {
      const payload = {
        karigar_id: karigar_id,
        from_date: fromdate,
        to_date: todate,
      };
      fetchKarigarAmountLedgerReport(payload);
    }
  }, []);

  const printTable = () => {
    window.print();
    return;
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <GridLayoutItem>
            <div
              className="printbuttons"
              style={{
                textAlign: "center",
                padding: "20px",
                display: "block",
              }}
            >
              {/* {isExcelExportAccess && (
                <Button
                  type="button"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handleExportExcel}
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                    backgroundColor: "#3b823b",
                  }}
                >
                  <PiMicrosoftExcelLogoFill style={{ fontSize: "20px" }} />{" "}
                  Excel Export
                </Button>
              )} */}
              {isPrintAccess && (
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={printTable}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              )}
            </div>
          </GridLayoutItem>
          <GridLayoutItem>
            <Typography.h5
              style={{
                marginBottom: 0,
                textAlign: "center",
              }}
            >
              Karigar Amount Ledger Report
            </Typography.h5>
            <Typography.h6
              style={{
                marginBottom: 15,
                textAlign: "center",
              }}
            >
              (
              {fromdate
                ? moment(fromdate, "YYYY-MM-DD").format("DD/MM/YYYY")
                : ""}
              {" to "}
              {todate ? moment(todate, "YYYY-MM-DD").format("DD/MM/YYYY") : ""})
            </Typography.h6>
          </GridLayoutItem>
          {/* REPORT LIST */}
          {KarigarAmountLedgerReportList &&
          KarigarAmountLedgerReportList.length > 0 ? (
            <div className="karigar-phine-ledger">
              <div className="table-container">
                <table className="ledger-table">
                  <thead>
                    <tr>
                      <th className="col-date">Date</th>
                      <th className="col-desc">Description</th>
                      <th className="col-issue-no">Issue No</th>
                      <th className="col-item">Item Name</th>
                      <th className="col-issue">Amount Issue</th>
                      <th className="col-receipt">Amount Receipt</th>
                      <th className="col-balance">Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {KarigarAmountLedgerReportList.map((data, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td className="cell-date">{data?.Date}</td>
                        <td
                          className="cell-desc"
                          style={{
                            fontWeight: index === 0 ? "bold" : "normal",
                          }}
                        >
                          {index === 0 ? `Opening Balance` : data?.karigar_name}
                        </td>
                        <td className="cell-issue-no">{data?.issue_no}</td>
                        <td className="cell-item">{data?.item_name}</td>
                        <td
                          className="cell-issue"
                          style={{
                            fontWeight: index === 0 ? "bold" : "normal",
                          }}
                        >
                          {formatToIndianCurrencyWithoutSymbol(
                            data?.amount_issue || 0
                          )}
                        </td>
                        <td
                          className="cell-receipt"
                          style={{
                            fontWeight: index === 0 ? "bold" : "normal",
                          }}
                        >
                          {formatToIndianCurrencyWithoutSymbol(
                            data?.amount_receipt || 0
                          )}
                        </td>
                        <td
                          className="cell-balance"
                          style={{
                            fontWeight: index === 0 ? "bold" : "normal",
                          }}
                        >
                          {formatToIndianCurrencyWithoutSymbol(
                            data?.closing_balance || 0
                          )}{" "}
                          {data.creditdebittype === "Credit" ? "Cr" : "Dr"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="totals-row">
                      <td colSpan={4} className="totals-label">
                        TOTALS
                      </td>
                      <td className="total-issue text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          sumBy(KarigarAmountLedgerReportList, "amount_issue")
                        )}
                      </td>
                      <td className="total-receipt text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          sumBy(KarigarAmountLedgerReportList, "amount_receipt")
                        )}
                      </td>
                      <td className="total-balance text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          KarigarAmountLedgerReportList?.at(-1)
                            ?.closing_balance ?? 0
                        )}{" "}
                        {KarigarAmountLedgerReportList?.at(-1)
                          ?.creditdebittype === "Credit"
                          ? "Cr"
                          : "Dr"}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          ) : null}
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default KarigarAmountLedgerReportView;
